"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _fetchApplicationServerKey = _interopRequireDefault(require("./fetchApplicationServerKey"));
var _register = _interopRequireDefault(require("./register"));
var _urlBase64ToUint8Array = _interopRequireDefault(require("./urlBase64ToUint8Array"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const subscribeToPushManager = async _ref => {
  let {
    lang,
    name
  } = _ref;
  try {
    const registration = await navigator.serviceWorker.register("/service-worker.js");
    if (!registration) return;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) return JSON.parse(JSON.stringify(subscription));
    const serverKey = await (0, _fetchApplicationServerKey.default)();
    if (!serverKey) return;
    const subscribeOptions = {
      userVisibleOnly: true,
      applicationServerKey: (0, _urlBase64ToUint8Array.default)(serverKey)
    };
    const pushSubscription = await registration.pushManager.subscribe(subscribeOptions);
    if (pushSubscription) {
      await (0, _register.default)({
        lang,
        name,
        pushSubscription: JSON.parse(JSON.stringify(pushSubscription))
      });
    }
    return;
  } catch (error) {
    console.error("subscription error:", error);
  }
};
var _default = exports.default = subscribeToPushManager;